var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCenterCompanies(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33342 12.25V2.91667C9.33342 2.60725 9.2105 2.3105 8.99171 2.09171C8.77291 1.87292 8.47617 1.75 8.16675 1.75H5.83342C5.524 1.75 5.22725 1.87292 5.00846 2.09171C4.78966 2.3105 4.66675 2.60725 4.66675 2.91667V12.25M2.33341 4.08333H11.6667C12.3111 4.08333 12.8334 4.60567 12.8334 5.25V11.0833C12.8334 11.7277 12.3111 12.25 11.6667 12.25H2.33341C1.68908 12.25 1.16675 11.7277 1.16675 11.0833V5.25C1.16675 4.60567 1.68908 4.08333 2.33341 4.08333Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterCompanies);
export default __webpack_public_path__ + "static/media/help-center-companies.124771afdfa9862820d7f3e9efb55b47.svg";
export { ForwardRef as ReactComponent };